import { defineMessages } from 'react-intl';

export const taxHintMessages = defineMessages({
  carrierDeliveryDEFAULT: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Service & Versandkosten</link>',
    id: 'taxHint.text.carrierDelivery.default',
  },
  carrierDeliveryL: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Speditionsgebühr</link>',
    id: 'taxHint.text.carrierDelivery.l',
  },
  carrierDeliveryS: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Speditionsgebühr</link>',
    id: 'taxHint.text.carrierDelivery.s',
  },
  titleDEFAULT: {
    defaultMessage: 'Service & Versandkosten',
    id: 'taxHint.dialog.headline.default',
  },
  titleL: {
    defaultMessage: 'Speditionsgebühr',
    id: 'taxHint.dialog.headline.l',
  },
  titleS: {
    defaultMessage: 'Speditionsgebühr',
    id: 'taxHint.dialog.headline.s',
  },
  dialogContent: {
    defaultMessage:
      'Je Bestellung und Lieferanschrift zahlen Sie für Standardlieferungen 6 € Versandkosten (unabhängig vom Bestellwert).',
    id: 'taxHint.dialog.text',
  },
});
